import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as o, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBookmarkFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, _, f, e) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--bookmark-filled"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Bookmark Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.516 1.484A1.438 1.438 0 0 0 8.5 1.063h-5A1.438 1.438 0 0 0 2.062 2.5v8a.437.437 0 0 0 .655.38L6 9.004l3.283 1.876a.438.438 0 0 0 .655-.38v-8c0-.381-.152-.747-.422-1.016Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ s(c, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=bookmark-filled.js.map
